/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SourceidSnapshotsBody model module.
 * @module model/SourceidSnapshotsBody
 * @version v0
 */
export default class SourceidSnapshotsBody {
  /**
   * Constructs a new <code>SourceidSnapshotsBody</code>.
   * @alias module:model/SourceidSnapshotsBody
   * @class
   * @param file {Blob} 
   */
  constructor(file) {
    this.file = file;
  }

  /**
   * Constructs a <code>SourceidSnapshotsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SourceidSnapshotsBody} obj Optional instance to populate.
   * @return {module:model/SourceidSnapshotsBody} The populated <code>SourceidSnapshotsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SourceidSnapshotsBody();
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {Blob} file
 */
SourceidSnapshotsBody.prototype.file = undefined;

